import { FMSearchParams } from './types';

export const AGENT_COOKIE = 'agentDetails';
export const AGENCY_COOKIE = 'agencyDetails';
export const AGENCY_CURRENCY_COOKIE = 'agencyCurrencyCode';

export const FM_AGENT_ID_KEY = FMSearchParams.agentId;
export const FM_AGENCY_ID_KEY = FMSearchParams.agencyId;
export const FM_BOOKING_CHANNEL_KEY = FMSearchParams.bookingChannel;

export const FM_RECOGNITION_KEY = 'fmRecognition';
